import EntityStats from "./EntityStats";
import _3DModelDetailLevel from "./enums/_3DModelDetailLevel";
import _3DModelFormat from "./enums/_3DModelFormat";
import _3DModelLicenseType from "./enums/_3DModelLicenseType";
import TextureFileType from "./enums/TextureFileType";
import TextureType from "./enums/TextureType";
import PathInfo from "./PathInfo";
import TextureFile from "./TextureFile";

class Texture {
  constructor(
    public id_user: number,
    public id_3Dinstance: number,
    public id_gltf_file: number | undefined,
    public icon: number | undefined,
    public name: string,
    public description: string,
    public sensor_configuration: string,
    public type: TextureType | undefined,
    public license_type: _3DModelLicenseType | undefined,
    public textures: TextureFile[] | undefined,
    public config?: string | undefined,
    public id?: number | undefined,
    public GUID?: string | undefined,
    public created_on?: string | undefined,
    public icon_path?: string | undefined,
    public gltf_name?: string | undefined,
    public textures_name?: string,
    public parent?: PathInfo,
    public counts?: EntityStats[] | undefined,
    public username?: string | undefined,
    public texture_meaning?: TextureFileType | undefined,
  ) {}

  public static EmptyInstance(): Texture {
    return new Texture(
      -1,
      -1,
      undefined,
      -1,
      "",
      "",
      "",
      undefined,
      undefined,
      undefined,
      "This field is deprecated. Will be removed.",
    );
  }
}

export default Texture;
